<template>
    <div>
        <pageHead :title="title" :btn-list="btnList" @handleBtn="handleBtn"></pageHead>
        <div class="content">
            <div class="search">
                <Form>
                    <row :gutter="80">
                        <i-col span="8">
                            <FormItem label="受理编号">
                                <div class="detail">{{info.estateNO}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="证书编号">
                                <div class="detail">{{info.certNO}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="印刷编号">
                                <div class="detail">{{info.printNO}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="发证时间">
                                <div class="detail">{{info.issueCertTime | formatData}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="发证人">
                                <div class="detail">{{info.issueUser}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="取证人">
                                <div class="detail">{{info.takeUser}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="取证人证件号">
                                <div class="detail">{{info.takeUserZjh}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label="取证时间">
                                <div class="detail">{{info.takeTime}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="8">
                            <FormItem label=" 项目（小区）">
                                <div class="detail">{{info.projectName}}</div>
                            </FormItem>
                        </i-col>
                        <i-col span="24">
                            <FormItem label="证书照片" prop="headPicUrl">
                                <img class="headPicUrl" :src="info.certPhoto" @click.stop="clickPic(info.certPhoto)" />
                            </FormItem>
                        </i-col>
                        <i-col span="24">
                            <FormItem label="取件人照片" prop="headPicUrl">
                                <img class="headPicUrl" :src="info.takeUserPhoto" @click.stop="clickPic(info.takeUserPhoto)" />
                            </FormItem>
                        </i-col>
                        <preview-img :currentIndex="0" :imgArr="showPreview.list" v-if="showPreview.show" v-on:closePreview="closePreview"></preview-img>
                    </row>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
import miment from "miment";
import PreviewImg from "../../../components/previewImg";

const {
    estatePrintLogDetail
} = api
export default {
    name: "leaseContractDetail",
    components: {
        pageHead,
        PreviewImg
    },
    filters: {
        formatData(value){
            return miment(Number(value)).format("YYYY-MM-DD")
        }
    },
    data() {
        return {
            title: "打印证书详情",
            btnList: [],
            info: [],
            showPreview: {
                show: 0,
                list: []
            } //预览图片
        }
    },
    methods: {
        handleBtn(){

        },
        async getDetail() {
            try {
                let res = await this.$get(estatePrintLogDetail, {
                    id: this.$route.query.id
                });
                if (res.isSucceed && res.rows) {
                    this.info = res.rows[0];
                }
            } finally {}
        },
        clickPic(val){
            this.showPreview.list = [];
            console.log(val);
            // this.imgArr.length>0 && this.imgArr.forEach(item=>{
            this.showPreview.list.push({
                isHeight: false,
                path: val
            });
            // })
            console.log(this.showPreview.list);
            this.showPreview.show = 1;
        },
        closePreview() {
            console.log("========closePreview==========");
            this.showPreview.show = 0;
        }
    },
    created(){
        this.getDetail()
    }
}
</script>

<style lang="less" scoped>
.content {
    margin: 20px;
}
.search {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    margin-bottom: 20px;
}
.detail {
    color: #666;
}
.headPicUrl {
    display: inline-block;
    height: 80px;
    width: 80px;
    margin-right: 20px;
    margin-bottom: 20px;
}
</style>